import React, { Component } from 'react';
import { Modal, Button, Col, Input, Row } from 'antd';
import ButtonClose from '../UI/ButtonClose';
import styles from './modal.less';
import Loading from '../Loading';

class Confirm extends Component {

  constructor() {
    super();
    this.state = {
      loading: false,
    };
  }

  onSave = () => {
    this.setState({loading: true})
    this.props.onSave && this.props.onSave( ()=> {
      this.props.onOk(); // to close modal
    });
  }

  onAbort = () => {
    this.props.onAbort && this.props.onAbort();
    this.props.onOk(); // to close modal
  }

  render() {
    const {loading} = this.state;
    const buttons = [];
    // для конфермов с 2 кнопками: ок, отена
    if (this.props.okText) {
      buttons.push(
        <Button key="submit" type="danger" onClick={this.props.onOk}>
          {this.props.okText}
        </Button>
      );
    }

    // для конфермов с 3 кнопками: да, нет, отмена
    if (this.props.saveText) {
      buttons.push(
        <Button key="submit" type="primary" onClick={this.onSave} disabled={loading}>
          {this.props.saveText}
        </Button> 
      );
    }
    if (this.props.abortText) {
      buttons.push(
        <Button key="abort" type="danger" onClick={this.onAbort} disabled={loading}>
          {this.props.abortText}
        </Button>
      );
    }

    if (this.props.cancelText) {
      buttons.push(
        <Button key="back" type="default" onClick={this.props.onCancel} disabled={loading}>
          {this.props.cancelText}
        </Button>
      );
    }

    if ( loading ) {
      buttons.push(
        <Loading key="loading" text="" styles={{display: "inline"}}/>
      );
    }

    return (
      <Modal
        open
        maskClosable={false}
        closable={false}
        confirmLoading={loading}
        footer={buttons}
      >
        <Row type="flex" justify="space-between" align="middle" className={styles.header}>
          <h1>{this.props.headerText}</h1>
          {!loading && (<ButtonClose large className={styles.close} shiftRight onClick={this.props.onCancel} />)}
        </Row>
        <Col className={styles.content}>
          <p>{this.props.text}</p>
          {this.props.confirmation && <Input type="text" />}
        </Col>
      </Modal>
    );
  }
}

export default Confirm;
